import { IFindAllOpportunityApprovalRequest } from '../../../../models/findAllOpportunityApprovalRequest.model';
import { AppAction } from '../../../../state/app';
import { FAILURE, REQUEST, SUCCESS } from '../../../../utils/actionTypeUtil';
import {
  CLEAR_PENDING_APPROVAL_ASSIGNMENT_LIST,
  FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST,
} from './pendingApprovalAssignmentList.actions';

export interface PendingApprovalAssignmentListState {
  loading: boolean;
  items: ReadonlyArray<IFindAllOpportunityApprovalRequest>;
  errorMessage: string;
  totalItems: number;
}

const initialState: PendingApprovalAssignmentListState = {
  errorMessage: '',
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: PendingApprovalAssignmentListState = initialState,
  action: AppAction,
): PendingApprovalAssignmentListState => {
  switch (action.type) {
    case REQUEST(FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PENDING_APPROVAL_ASSIGNMENT_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case CLEAR_PENDING_APPROVAL_ASSIGNMENT_LIST:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
